import { EnumOption } from './enum-option';
import { createEnumOptions } from '../../shared/utils';

export enum ProcessStepStatus {
  'Not Started' = 0,
  'In Progress' = 1,
  Completed = 2,
  Skipped = 3,
}

export const MatterProcessStepStatusList: EnumOption[] = createEnumOptions(ProcessStepStatus);
